import initPolyfills from './polyfills'
import { configureLazySizes } from './initLazySizes'

configureLazySizes()

initPolyfills().then(() => {
  require('./hydrateApp')
})
